import http from "./http-common";
import AboutUsModel from "../models/aboutUs";
import ContactUsModel from "../models/contactUs";
import StaffModel from "../models/staff";

// About Us APIs
// eslint-disable-next-line
export default new (class AboutUsService {
  // Get all about us
  async getContent() {
    return await http
      .get("/abouts?populate=*")
      .then(async (response) => {
        const data = await Promise.all(
          response.data.data.map((aboutUs) => AboutUsModel.get(aboutUs))
        );

        return data.sort((a, b) => a.order - b.order);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  // Get all contact us
  async getContact() {
    return await http
      .get("/about-contact-uses?populate=deep")
      .then(async (response) => {
        const data = await Promise.all(
          response.data.data.map((contact) => ContactUsModel.get(contact))
        );

        return data.sort((a, b) => a.order - b.order);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  // Get all staff
  async getStaff() {
    return await http
      .get("/about-staffs?populate=deep")
      .then(async (response) => {
        const data = await Promise.all(
          response.data.data
            .filter((staff) => staff.id === 1)
            .map((item) => StaffModel.get(item))
        );

        return data[0];
      })
      .catch((error) => {
        console.log(error);
      });
  }

  // Get all Doctor
  async getDoctor() {
    return await http
      .get("/about-staffs?populate=deep")
      .then(async (response) => {
        const data = await Promise.all(
          response.data.data
            .filter((staff) => staff.id === 2)
            .map((item) => StaffModel.get(item))
        );

        return data[0];
      })
      .catch((error) => {
        console.log(error);
      });
  }
})();
